import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Divider, Input } from 'antd';
import { Flex, Text } from '../../shared/components';
import GraduacionBar from '../components/bars/GraduacionBar';
import {
  setSeleccionGraduacion,
  setGraduacionGenerica,
  setSeleccionIndice,
  setSeleccionPasillo,
  setSeleccionFabricante,
  setSeleccionColor,
  getLentesTiposPvpsRequest,
  getMisColoresRequest,
  getMisFabricantesRequest,
  getMisPasillosRequest,
  getMisIndicesRequest,
  setSearchLentesValue,
  clearToolbarDatos,
  setSeleccionLenteTipoPvp, setDiametroMinimo, getLentesListRequest, getOrdenGraduacionRequest, setFueraDeNorma,
} from '../../../state/actions/creators/pel.actioncreator';
import Box from '../../shared/components/basic/Box';
import IndicesYColoracionBar from '../components/bars/IndicesYColoracionBar';
import ProveedoresBar from '../components/bars/ProveedoresBar';
import PasillosBar from '../components/bars/PasillosBar';
import DiametrosBar from '../components/bars/DiametrosBar';
import EncargoBar from '../components/bars/EncargoBar';
import { LEJOS } from '../constants/graduacion';

class PELSeleccionToolbar extends Component {
  componentWillMount() {
    const {
      gamaColor, getMisColoresRequest, getMisFabricantesRequest, getLentesTiposPvpsRequest,
      getMisPasillosRequest, getMisIndicesRequest, clearToolbarDatos, getOrdenGraduacionRequest,
    } = this.props;
    clearToolbarDatos();
    getOrdenGraduacionRequest();
    getMisColoresRequest(gamaColor);
    getLentesTiposPvpsRequest(gamaColor);
    getMisFabricantesRequest();
    getMisIndicesRequest();
    getMisPasillosRequest();
  }

  render() {
    const {
      setSeleccionGraduacion,
      setGraduacionGenerica,
      setSeleccionIndice,
      setSeleccionFabricante,
      setSeleccionPasillo,
      setSeleccionColor,
      setSearchLentesValue,
      setSeleccionLenteTipoPvp,
      setDiametroMinimo,
      setFueraDeNorma,
      getLentesListRequest,
      lentesTiposPvps,
      graduacion,
      misFabricantes,
      fabricante,
      indices,
      indicesPreSeleccionados,
      parametrosMonturaEsablecidos,
      indicesRequestStatus,
      gamaColor,
      ordenGraduacion,
      lentesGamasColores,
      misColores,
      coloresRequestStatus,
      fabricantesRequestStatus,
      lenteTipoPvp,
      lentesTiposPvpsRequestStatus,
      pasillosRequestStatus,
      categorias,
      pasillos,
      montura,
      focos,
      permisos,
      modoNoPel,
      modo,
      fueraDeNorma,
    } = this.props;
    const usaMiCatalogoIndices = modoNoPel ? 0 : 1;
    const indicesUsados = indices.filter(e => e.esMiCatalogo === usaMiCatalogoIndices);
    return (
      <Box p="16" w="100%">
        <Flex justifyContent="space-between" alignItems="baseline">
          <GraduacionBar
            initialValues={graduacion}
            vision={focos.modo}
            permisos={permisos}
            modo={modo}
            ordenGraduacion={ordenGraduacion}
            onOjoCheckboxChange={ojos => setSeleccionGraduacion(ojos)}
            onGraduacionChange={(e, tipo) => setGraduacionGenerica(e, tipo)}
            setSeleccionPasillo={setSeleccionPasillo}
            getLentesListRequest={getLentesListRequest}
            setFueraDeNorma={setFueraDeNorma}
            fueraDeNorma={fueraDeNorma}
          />
          <DiametrosBar modo={modo} permisos={permisos} parametrosMonturaEsablecidos={parametrosMonturaEsablecidos} diametro={montura.diametroMinimo} setDiametroMinimo={setDiametroMinimo} />
        </Flex>
        <Input.Search
          placeholder="Buscar lentes por nombre, precio, fabricante, propiedad..."
          onSearch={value => setSearchLentesValue(value)}
          style={{ width: '100%', marginTop: 16 }}
        />
        <Divider style={{
          position: 'relative !important', width: 1061, marginTop: 16, marginBottom: 16,
        }}
        />
        <Flex justifyContent="space-between" alignItems="baseline">
          <Flex>
            <ProveedoresBar
              hide={!modoNoPel && modo !== 'consulta'}
              misFabricantes={misFabricantes}
              miFabricante={fabricante}
              loading={fabricantesRequestStatus.running || fabricantesRequestStatus.httpCode === 0}
              handleChange={setSeleccionFabricante}
            />
            {(modo === 'consulta' && !modoNoPel)
          && (
          <EncargoBar
            lentesTiposPvps={lentesTiposPvps}
            lenteTipoPvp={lenteTipoPvp}
            loading={lentesTiposPvpsRequestStatus.running || lentesTiposPvpsRequestStatus.httpCode === 0}
            handleChange={setSeleccionLenteTipoPvp}
          />
          )
          }
          </Flex>
          <Flex alignItems="baseline">
            <IndicesYColoracionBar
              indices={indicesUsados}
              indicesPreSeleccionados={indicesPreSeleccionados}
              colores={misColores}
              lentesGamasColores={lentesGamasColores}
              handleChangeIndices={setSeleccionIndice}
              handleChangeColoracion={setSeleccionColor}
              modoNoPel={modoNoPel}
              trabajaConColores={permisos ? permisos.configuracion.micatalogo_colores_personalizados !== 'N' : false}
              loadingColores={coloresRequestStatus.running || coloresRequestStatus.httpCode === 0}
              loadingIndices={indicesRequestStatus.running || indicesRequestStatus.httpCode === 0}
              drawColoracion={!modoNoPel && ((gamaColor && gamaColor.tipo_id !== 1) || !gamaColor)}
              drawIndices={indicesUsados.length > 0}
              modo={modo}
            />
            <PasillosBar
              pasillos={pasillos}
              loading={pasillosRequestStatus.running || pasillosRequestStatus.httpCode === 0}
              handleChange={setSeleccionPasillo}
              hide={modoNoPel || (categorias && categorias.clasificacion_foco_id !== 2)
              || (modo === 'consulta' && graduacion && graduacion.generico && (graduacion.generico.ADD === null || graduacion.generico.ADD === ''))}
            />
          </Flex>
        </Flex>
      </Box>
    );
  }
}
const mapStateToProps = ({ pel, sagas, auth }) => ({
  modo: pel.modo,
  modoNoPel: pel.modoNoPel,
  permisos: auth.permisos,
  parametrosMonturaEsablecidos: pel.filtrador.parametrosMonturaEsablecidos,
  fueraDeNorma: pel.filtrador.fueraDeNorma,
  catalogo: pel.filtrador.selecciones.catalogo,
  graduacion: pel.filtrador.selecciones.graduacion,
  ordenGraduacion: pel.filtrador.selecciones.ordenGraduacion,
  categorias: pel.filtrador.selecciones.categorias,
  montura: pel.filtrador.selecciones.montura,
  pasillos: pel.filtrador.selecciones.pasillos,
  indices: pel.filtrador.selecciones.indices,
  indicesPreSeleccionados: pel.filtrador.selecciones.grosores,
  gamaColor: pel.filtrador.selecciones.colores,
  focos: pel.filtrador.selecciones.focos,
  misColores: pel.filtrador.buscador.misColores,
  usaMiCatalogo: pel.usaMiCatalogo,
  lentesGamasColores: pel.filtrador.formulario.colores.opciones,
  misFabricantes: pel.filtrador.buscador.misFabricantes,
  lentesTiposPvps: pel.filtrador.buscador.lentesTiposPvps,
  lenteTipoPvp: pel.filtrador.selecciones.lenteTipoPvp,
  fabricante: pel.filtrador.selecciones.miFabricante,
  coloresRequestStatus: sagas.LENTES_PEL_GET_COLORES,
  fabricantesRequestStatus: sagas.LENTES_PEL_GET_FABRICANTES,
  pasillosRequestStatus: sagas.LENTES_PEL_GET_PASILLOS,
  indicesRequestStatus: sagas.LENTES_PEL_GET_INDICES,
  lentesTiposPvpsRequestStatus: sagas.LENTES_PEL_GET_LENTESTIPOSPVP,

});
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setSeleccionGraduacion,
    setGraduacionGenerica,
    setSeleccionIndice,
    setSeleccionFabricante,
    setSeleccionPasillo,
    setSeleccionColor,
    setSeleccionLenteTipoPvp,
    setDiametroMinimo,
    setSearchLentesValue,
    getMisColoresRequest,
    getMisFabricantesRequest,
    getLentesTiposPvpsRequest,
    getMisPasillosRequest,
    getMisIndicesRequest,
    getLentesListRequest,
    getOrdenGraduacionRequest,
    clearToolbarDatos,
    setFueraDeNorma,
  }, dispatch);
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PELSeleccionToolbar);

PELSeleccionToolbar.propTypes = {
  graduacion: PropTypes.shape({ generico: PropTypes.shape({ ADD: PropTypes.string }) }).isRequired,
  catalogo: PropTypes.shape({ id: PropTypes.number }),
  indices: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  montura: PropTypes.shape({ diametroMinimo: PropTypes.number }).isRequired,
  categorias: PropTypes.shape({ id: PropTypes.number, clasificacion_foco_id: PropTypes.number }).isRequired,
  modo: PropTypes.string.isRequired,
  ordenGraduacion: PropTypes.string,
  parametrosMonturaEsablecidos: PropTypes.bool,
  usaMiCatalogo: PropTypes.bool.isRequired,

  setSeleccionGraduacion: PropTypes.func.isRequired,
  setGraduacionGenerica: PropTypes.func.isRequired,
  setSeleccionIndice: PropTypes.func.isRequired,
  setSeleccionFabricante: PropTypes.func.isRequired,
  setSeleccionColor: PropTypes.func.isRequired,
  setSeleccionPasillo: PropTypes.func.isRequired,
  setSeleccionLenteTipoPvp: PropTypes.func.isRequired,
  setDiametroMinimo: PropTypes.func.isRequired,
  setSearchLentesValue: PropTypes.func.isRequired,
  getMisColoresRequest: PropTypes.func.isRequired,
  getMisFabricantesRequest: PropTypes.func.isRequired,
  getLentesTiposPvpsRequest: PropTypes.func.isRequired,
  getOrdenGraduacionRequest: PropTypes.func.isRequired,
  getMisPasillosRequest: PropTypes.func.isRequired,
  getMisIndicesRequest: PropTypes.func.isRequired,
  getLentesListRequest: PropTypes.func.isRequired,
  clearToolbarDatos: PropTypes.func.isRequired,

  gamaColor: PropTypes.shape({
    id: PropTypes.number,
    categoria_id: PropTypes.number,
    clasificacion_foco_id: PropTypes.number,
    gama_color: PropTypes.string,
    nombre: PropTypes.string,
    valor: PropTypes.number,
    empresa_id: PropTypes.number,
    tipo_id: PropTypes.number,
    activa: PropTypes.bool,
    oculta: PropTypes.bool,
    foto: PropTypes.string,
  }).isRequired,
  focos: PropTypes.shape({
    id: PropTypes.number,
    modo: PropTypes.string,
  }),
  misColores: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    empresaId: PropTypes.number,
    esCliente: PropTypes.number,
    nombre: PropTypes.string,
    gamaColor: PropTypes.number,
    activa: PropTypes.number,
    fechaModificacion: PropTypes.string,
  })).isRequired,
  misFabricantes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    empresaId: PropTypes.number,
    esCliente: PropTypes.bool,
    proveedor: PropTypes.string,
    activa: PropTypes.number,
  })).isRequired,
  lentesTiposPvps: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    descripcion: PropTypes.string,
  })).isRequired,
  pasillos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    descripcion: PropTypes.string,
  })).isRequired,
  coloresRequestStatus: PropTypes.shape({
    running: PropTypes.bool,
    success: PropTypes.bool,
    httpCode: PropTypes.number,
  }),
  fabricantesRequestStatus: PropTypes.shape({
    running: PropTypes.bool,
    success: PropTypes.bool,
    httpCode: PropTypes.number,
  }),
  pasillosRequestStatus: PropTypes.shape({
    running: PropTypes.bool,
    success: PropTypes.bool,
    httpCode: PropTypes.number,
  }),
  indicesRequestStatus: PropTypes.shape({
    running: PropTypes.bool,
    success: PropTypes.bool,
    httpCode: PropTypes.number,
  }),
  lentesTiposPvpsRequestStatus: PropTypes.shape({
    running: PropTypes.bool,
    success: PropTypes.bool,
    httpCode: PropTypes.number,
  }),
};

PELSeleccionToolbar.defaultProps = {
  coloresRequestStatus: {
    running: false,
    success: false,
    httpCode: 0,
  },
  fabricantesRequestStatus: {
    running: false,
    success: false,
    httpCode: 0,
  },
  pasillosRequestStatus: {
    running: false,
    success: false,
    httpCode: 0,
  },
  indicesRequestStatus: {
    running: false,
    success: false,
    httpCode: 0,
  },
  lentesTiposPvpsRequestStatus: {
    running: false,
    success: false,
    httpCode: 0,
  },
  focos: {
    modo: LEJOS,
  },
  parametrosMonturaEsablecidos: false,
  catalogo: null,
  ordenGraduacion: null,
};
